import { CommonModule } from "@angular/common"
import { Component, Inject } from "@angular/core"
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog"

@Component({
	selector: "wfdss-a-notes-delete-dialog",
	imports: [CommonModule],
	templateUrl: "./a-notes-delete-dialog.component.html",
	styleUrl: "./a-notes-delete-dialog.component.scss",
})
export class AnalysisNotesDeleteDialogComponent {
	constructor(
		public ref: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public data: any,
	) {}
	onClickCancelDelete() {
		this.ref.close("cancel")
	}
	onConfirmDelete() {
		this.ref.close("delete")
	}
}
